import React, { useState } from 'react';
import {
  FaArrowRight,
  FaBookOpen,
  FaCogs,
  FaInfoCircle,
  FaMotorcycle,
  FaPaintRoller,
  FaStar,
  FaTools,
  FaWrench,
} from 'react-icons/fa';
import SupplierCard from './SupplierCard';
import suppliersData from '../../Data/Suppliers.json'; // Import the JSON file with supplier data
import amcSparesLogo from '../../assets/amcSpares.png';
import './Suppliers.css';

const supplierCategories = [
  { title: 'Engine Parts', icon: FaCogs },
  { title: 'Restoration Services', icon: FaTools },
  { title: 'Paint & Finishing', icon: FaPaintRoller },
  { title: 'Tyres & Wheels', icon: FaWrench },
  { title: 'Books & Literature', icon: FaBookOpen },
  { title: 'Specialists', icon: FaMotorcycle },
];

const SuppliersPage = () => {
  const [suppliers] = useState(suppliersData || []);
  const supplierOfTheMonth = undefined
   // suppliers.find((supplier) => supplier.name === 'AMC Classic Spares') || suppliers[0];

  return (
    <main className="suppliers-page">
      <div className="suppliers-page__frame">
     
        {supplierOfTheMonth && (
          <section className="supplier-month">
            <div className="supplier-month__badge">
              <span><FaStar aria-hidden="true" /> Supplier of the Month <FaStar aria-hidden="true" /></span>
              <img src={amcSparesLogo} alt="AMC Classic Spares logo" />
            </div>
            <div className="supplier-month__copy">
              <h2>{supplierOfTheMonth.name}</h2>
              <p>
                {supplierOfTheMonth.details}. A trusted source for AJS and Matchless
                parts, advice and specialist support.
              </p>
              {supplierOfTheMonth.website && (
                <a href={supplierOfTheMonth.website} target="_blank" rel="noopener noreferrer">
                  Visit Website <FaArrowRight aria-hidden="true" />
                </a>
              )}
            </div>
            <div className="supplier-month__image" aria-hidden="true" />
          </section>
        )}

        <section className="supplier-section-heading">
          <h2>Suppliers by Category</h2>
        </section>

        <section className="supplier-category-grid" aria-label="Supplier categories">
          {supplierCategories.map(({ title, icon: Icon }) => (
            <article key={title} className="supplier-category-card">
              <Icon aria-hidden="true" />
              <h3>{title}</h3>
              <span>
                View suppliers <FaArrowRight aria-hidden="true" />
              </span>
            </article>
          ))}
        </section>

        <section className="supplier-section-heading">
          <h2>Featured Suppliers</h2>
        </section>

        <section className="suppliers-page__grid" aria-label="Featured suppliers">
          {suppliers.slice(0, 3).map((supplier) => (
            <SupplierCard key={supplier.id} supplier={supplier} isFeatured />
          ))}
        </section>

        <section className="suppliers-page__grid suppliers-page__grid--secondary" aria-label="More trusted suppliers">
          {suppliers.slice(3).map((supplier) => (
            <SupplierCard key={supplier.id} supplier={supplier} />
          ))}
        </section>

        <section className="supplier-recommend">
          <div className="supplier-recommend__image" aria-hidden="true" />
          <div>
            <h2>Recommend a Supplier</h2>
            <p>Do you know a great supplier that other members would benefit from?</p>
            <a href="mailto:southwest@jampot.com?subject=Supplier recommendation">
              Recommend a Supplier <FaArrowRight aria-hidden="true" />
            </a>
          </div>
          <div className="supplier-recommend__note">
            <FaInfoCircle aria-hidden="true" />
            <div>
              <h3>Please Note</h3>
              <p>
                Suppliers are listed for information only. The Devon &amp; Cornwall
                Section cannot be held responsible for external goods or services.
              </p>
            </div>
          </div>
        </section>

       
      </div>
    </main>
  );
};

export default SuppliersPage;
